export const properties = {
    productionUrl: "https://zerozerosei.top",
    //productionUrl: "https://eduteche.it",
    //productionUrl: "http://localhost:8080",    
    version: "1.45"
};

//TO DO
//Ricordarsi di abilitare i due script in index.html per usercentric


/*
TO DO PER RIPRISTINARE LA SITUAZIONE FUNZIONANTE:
- Togliere if in dashboard.js in modo da far sparire il fine estate per ruoli diversi da AM, CSP e ADMIN
- sostituire il file MyAdmin.js con MyAdmin_OK.js
- Ricordarsi la modifica per differenziare user-ente da abbonamento musei
validate={validateDurationFields} 
*/



//DISPONIBILITA (slots): aggiungere riferimento ambito (ambito_id) sia in create sia in edit sia in view
//LIST: ok
//EXPORTER: ok
//FILTRO PER ambito e per ente: ok
//EDIT: ok
//CREATE: ok


//ENTI: resta così e togliamo create: OK
//TIPOLOGIA_ID eliminare dappertutto (da tabella ente) : ok c'era un solo riferimento
//UTENTI : resta così
//GENITORI: resta così
//BAMBINI: resta così
//ISCRIZIONI, PRENOTAZIONI e TITOLI Vanno duplicati per ogni ambito 

//ACCOMPAGNATORI: ok create, edit, list + filti e export

//Tabella ambiti: id, label
//
//1 Spazio Gioco
//
//2 Centro Bambini-Famiglie
//
//3 Ludoteche 0/3
//
//4 Ludoteche 3/6
//
//5 Ludoteche 6/10
//
//6 Ludoteche 10/14




//Admin:  1,2,3,4,5,6
//Aquilone: 1
//Paguro: 1
//Drago Volante: 2,4,5,6
//Agorà: 1,2,3,4,5,6
//Cinciallegra: 1,2,3,4

//TO DO:
//SUL CREATE ISCRIZIONI per admin necessario filtrare per mostrare solo gli enti che offrono quel certo servizio